/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorShowsSlider from 'base/components/labrador/ShowsSlider';

export const DynamicLabradorShowsSlider: typeof LabradorShowsSlider = (props) => {
    return <ErrorBoundary><LabradorShowsSlider {...props} /></ErrorBoundary>;
}
export type DynamicLabradorShowsSliderProps = PropsFromComponent<typeof LabradorShowsSlider>;
